import { Component, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { QrCodeData } from '../../../../../core/models';
import { DialogComponent } from '../../../../../core/models/dialog.data';

@Component({
  selector: 'dbx-qr-code-dialog',
  standalone: true,
  imports: [MatButton, MatIcon, TranslatePipe, MatDialogTitle, MatDialogContent, MatDialogActions],
  templateUrl: './qr-code-dialog.component.html',
  styleUrl: './qr-code-dialog.component.scss',
})
export class QrCodeDialogComponent extends DialogComponent<QrCodeDialogComponent, QrCodeData> {
  private readonly dialogData = inject<QrCodeData>(MAT_DIALOG_DATA);

  qrCode = this.dialogData;

  downloadQRCode() {
    const link = document.createElement('a');
    link.href = this.qrCode.url;
    link.download = this.qrCode.filename;
    // why this? because some browsers ignore clicks on detached element
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(link.href);
    document.body.removeChild(link);
  }

  printQRCode(): void {
    const newWindow = window.open(this.qrCode.url, '_blank');
    if (newWindow) {
      newWindow.print();
    }
  }
}
